// Every colour, opacity, width and dash of the trade map, from the design
// addendum (2026-09-23) items 3, 4, 5 and 8. The SVG applies these as inline
// attributes and the canvas painter reads the same constants, so the page and
// the PNG cannot drift. TradeMapSvg.css holds ONLY animation, dim states and
// layout; a test pins that it carries no colour and no stroke width.

export const THEME = {
  /** Container and card background: a soft radial from the first to the second */
  backgroundInner: '#15131d',
  backgroundOuter: '#0a0a0d',
  backgroundRadius: 14,

  /** Countries the owner has traded with get the lighter fill */
  landTraded: '#26222f',
  landTradedStroke: '#3a3448',
  land: '#18181d',
  landStroke: '#2a2931',
  landStrokeWidth: 0.5,
  /** 10-degree graticule at 3.5% white */
  graticule: 'rgba(255, 255, 255, 0.035)',
  graticuleWidth: 0.5,

  /** Received arcs bow up in green, sent arcs bow down in violet */
  inbound: '#4ade80',
  outbound: '#a78bfa',
  completedArcOpacity: 0.5,

  /** In-transit overlay: dashed, on a pathLength=1 path */
  liveDashArray: '0.035 0.065',
  liveDash: [0.035, 0.065] as const,
  liveStrokeWidth: 2,
  liveRingWidth: 1.5,
  /** The package dot riding a live arc (round 2 spec): a blurred glow in the arc colour at 90% under a white core */
  packageCore: '#ffffff',
  packageGlowOpacity: 0.9,

  /** Partner dots: white 10% fill, white 78% stroke */
  dotFill: 'rgba(255, 255, 255, 0.10)',
  dotStroke: 'rgba(255, 255, 255, 0.78)',
  dotStrokeWidth: 1.25,

  /** Home: cream dot with a 45% cream halo ring */
  home: '#f5e2be',
  homeHalo: 'rgba(245, 226, 190, 0.45)',
  homeRadius: 4.5,
  homeHaloRadius: 9,
  homeHaloWidth: 1.5,
} as const;

export const directionColor = (direction: 'inbound' | 'outbound'): string =>
  direction === 'inbound' ? THEME.inbound : THEME.outbound;
